import { Route, Routes } from 'react-router';

import RiskObjectsDetail from './RiskObjectsDetail';
import RiskObjectsOverview from './RiskObjectsOverview';

export default function RiskObjectsRoutes() {
  return (
    <Routes>
      <Route index element={<RiskObjectsOverview />} />
      <Route path="/:id" element={<RiskObjectsDetail />} />
    </Routes>
  );
}
